import { InviteUser } from "../constants/invite_user";
export var inviteUserToOrganisation = function (email, organisation_id, role) {
    return {
        type: InviteUser.InviteUserToOrganisation,
        email: email,
        organisation_id: organisation_id,
        role: role,
    };
};
export var inviteUserToSuperorg = function (email, superorg_id, role) {
    return {
        type: InviteUser.InviteUserToSuperorg,
        email: email,
        superorg_id: superorg_id,
        role: role,
    };
};
export var fetchTeamMembers = function () {
    return {
        type: InviteUser.FetchTeamMembers,
    };
};
export var clearInviteMessage = function () {
    return {
        type: InviteUser.ClearInviteMessage,
    };
};
export var fetchPendingInvites = function (org_id, user_type) {
    return {
        type: InviteUser.FetchPendingInvites,
        org_id: org_id,
        user_type: user_type,
    };
};
export var revokeInvite = function (token) {
    return {
        type: InviteUser.RevokeInvite,
        token: token,
    };
};
export var resendInvite = function (token, email) {
    return {
        type: InviteUser.ResendInvite,
        token: token,
        email: email,
    };
};
